<template>
    <div>
        <div class="vx-card p-2">
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full flex items-center">
                    <h4>Cấu hình tổng đài</h4>
                </div>
                <div class="vx-col md:w-1/2 w-full flex justify-end gap-3">
                    <vs-button color="primary" icon-pack="feather" icon="icon-settings"
                               v-if="!isChangeConfig"
                               @click="isChangeConfig = true">
                        {{ $t('settings.addSetting') }}
                    </vs-button>
                    <vs-button @click="saveData" icon-pack="feather" icon="icon-check" v-if="isChangeConfig">
                        {{ $t('button.save') }}
                    </vs-button>
                    <vs-button class="" color="danger" type="border" icon-pack="feather" icon="icon-x"
                               @click="cancelSetting"
                               v-if="isChangeConfig">
                        {{ $t('settings.close') }}
                    </vs-button>

                </div>
            </div>
        </div>
        <div class="mt-4">
            <VuePerfectScrollbar class="scroll-area--config-pancake list-seeder vx-col w-full" :settings="settings"
                                 :key="$vs.rtl">
                <draggable @end="endMove($event)" :list="dataConfig" v-bind="dragOptions" @start="isDraging = true"
                           handle=".handle">
                    <transition-group type="transition" :name="!isDraging ? 'flip-list' : null">
                        <div v-for="(item, index) in dataConfig" :key="index" class="vx-card px-6 py-2 mt-4 ">
                            <div class="vx-row">
                                <div
                                    :class="isChangeConfig ? 'vx-col w-1/12 flex item-center justify-center' : 'hidden'">
                                    <feather-icon svg-classes="h-6 w-6" icon="MenuIcon"
                                                  class="text-primary lg:mt-6 handle"></feather-icon>
                                </div>
                                <div :class="isChangeConfig ? 'vx-col lg:w-3/12 w-full' : 'vx-col lg:w-4/12 w-full'">
                                    <label class="vs-input--label">Tên</label>
                                    <vs-input v-model="item.name" class="w-full" v-validate="'required'" name="name"
                                              :readonly="!isChangeConfig"/>
                                    <span class="text-danger text-sm">{{ errors.first('name') }}</span>
                                </div>
                                <div
                                    :class="isChangeConfig ? 'vx-col lg:w-3/12 w-full lg:mt-0 mt-2' : 'vx-col lg:w-4/12 w-full'">
                                    <label class="vs-input--label">Loại</label>
                                    <v-select class="" v-model="item.type" :clearable="false"
                                              :options="typeOptions" :reduce="option => option.value"
                                              :disabled="!isChangeConfig">
                                    </v-select>
                                    <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                                </div>
                                <div
                                    :class="isChangeConfig ? 'vx-col lg:w-3/12 w-full lg:mt-0 mt-2' : 'vx-col lg:w-4/12 w-full'">
                                    <label class="vs-input--label">{{ item.type === 0 ? 'Tổng đài' : 'Nhánh' }}</label>
                                    <vs-input v-model="item.phoneNumber" class="w-full" v-validate="'required'"
                                              name="phoneNumber"
                                              :readonly="!isChangeConfig"/>
                                    <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                                </div>
                                <div
                                    :class="isChangeConfig ? 'vx-col w-1/12 flex item-center justify-center' : 'hidden'">
                                    <vx-tooltip :text="$t('button.delete')" v-if="dataConfig.length > 1"
                                                class="flex items-center lg:mt-6 mt-2">
                                        <feather-icon svg-classes="h-6 w-6" icon="XSquareIcon" class="text-danger"
                                                      @click=" removeItem(index)"></feather-icon>
                                    </vx-tooltip>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </draggable>

                <div class="mt-8" v-if="isChangeConfig">
                    <vs-button icon-pack="feather" icon="icon-plus" @click="addItem">{{
                            $t('settings.add')
                        }}
                    </vs-button>
                </div>
            </VuePerfectScrollbar>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import vSelect from 'vue-select';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    name: "ConfigTelecom",
    components: {
        draggable,
        vSelect,
        VuePerfectScrollbar
    },

    data() {
        return {
            typeOptions: [
                {value: 0, label: 'Gọi thường'},
                {value: 1, label: 'Gọi OTT'},
            ],
            selectedType: null,
            isChangeConfig: false,
            dataConfig: [],
            isDraging: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.70,
            },
        }
    },

    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },


    created() {
        this.getConfigTele();
    },

    methods: {
        getConfigTele() {
            this.$vs.loading();

            this.$crm.get('/setting/organization-contact-setting/find-by-organization-id').then(res => {
                this.$vs.loading.close();
                this.dataConfig = res.data;
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        endMove() {
            this.isDraging = false;
            // if (this.dataConfig && this.dataConfig.length > 0) {
            //     this.dataConfig.forEach((el, index) => {
            //         return el.order = index;
            //     });
            // }
        },

        saveData() {
            this.$vs.loading();
            this.$crm.post('/setting/organization-contact-setting/save', this.dataConfig).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Cập nhật cấu hình tổng đài thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.isChangeConfig = false;
                this.getConfigTele();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        cancelSetting() {
            this.isChangeConfig = false;
            this.getConfigTele();
        },

        addItem() {
            this.dataConfig.push({name: '', type: 0, phoneNumber: ''})
        },
        removeItem(index) {
            this.dataConfig.splice(index, 1);
            // if (this.dataConfig && this.dataConfig.length > 0) {
            //     this.dataConfig.forEach((el, index) => {
            //         return el.order = index;
            //     });
            // }
        },

    }
}
</script>

<style scoped>

</style>
